import type { GMetrixTableHandle } from 'components/GMetrixTable/GMetrixTable';
import { FormattedMessage, useIntl } from 'react-intl';
import { Dropdown } from 'react-bootstrap';

type GMetrixTableExportTriggerProps = {
    handle: GMetrixTableHandle;
    type: 'button' | 'dropdown';
};

export const GMetrixTableExportTrigger = (props: GMetrixTableExportTriggerProps) => {

    const { handle, type } = props;
    const { formatMessage } = useIntl();

    const handleExport = (format: 'excel' | 'csv') => {

        if (!handle) return;

        switch (format){

            case 'csv':
                return handle.exportCSV();
            case 'excel':
                return handle.exportExcel();

        }

    };

    return (
        <>

            {type === 'button' ?
                (
                    <Dropdown>
                        <Dropdown.Toggle className={'d-inline-flex align-items-center gap-2'} variant={'outline-primary'}>
                            <div className={'d-inline-flex align-items-center gap-1'}>
                                <i className={'fa-regular fa-download'} />
                                <span>
                                    <FormattedMessage defaultMessage="Export" id="export.6f7a465c" />
                                </span>
                            </div>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item className={'d-inline-flex align-items-center gap-1'} onClick={() => handleExport('excel')}>
                                <i className={'fa-solid fa-file-excel'} />
                                <span>

                                    <FormattedMessage defaultMessage="Excel" id="excel.8369d601" />
                                </span>
                            </Dropdown.Item>
                            <Dropdown.Item className={'d-inline-flex align-items-center gap-1'} onClick={() => handleExport('csv')}>
                                <i className={'fa-solid fa-file-csv'} />
                                <span>

                                    <FormattedMessage defaultMessage="CSV" id="csv.366c59b0" />
                                </span>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>

                )
                :
                (
                    <>
                        <Dropdown.Item onClick={() => handleExport('excel')}>
                            <span>
                                {`${formatMessage({ id: 'export.6f7a465c', defaultMessage: 'Export' })} Excel`}
                            </span>
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => handleExport('csv')}>
                            <span>
                                {`${formatMessage({ id: 'export.6f7a465c', defaultMessage: 'Export' })} CSV`}
                            </span>
                        </Dropdown.Item>
                    </>
                )

            }
        </>
    );

};